import { Identifiable, Project, Resource, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  tasks: Identifiable<Task>[];
};

function getTasks(httpClient: HttpClient) {
  return (project: Identifiable<Project>, resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${project.uuid}/tasks-without-rls?resourceUuid=${resource.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ tasks }) => (tasks ? tasks : []))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getTasks };
